module.exports = __webpack_public_path__ + "img/loader.e606a928.svg";